import React from "react";

function BenefitPeriod({ periodType = "week" }) {
  const now = new Date(new Date().getTime() + 9 * 60 * 60 * 1000); // 한국 시간으로 설정

  let startDate, endDate;

  if (periodType === "month") {
    // 한 달의 시작일과 종료일 계산
    startDate = new Date(now.getFullYear(), now.getMonth(), 1); // 이번 달 1일
    endDate = new Date(now.getFullYear(), now.getMonth() + 1, 0); // 이번 달 마지막 날
  } else {
    // 주간의 시작일과 종료일 계산 (기본값)
    startDate = new Date(now.setDate(now.getDate() - now.getDay() + 1)); // 이번 주 월요일
    endDate = new Date(startDate.getTime() + 6 * 24 * 60 * 60 * 1000); // 이번 주 일요일
  }

  const formatDate = (date) => {
    return `${date.getFullYear()}. ${(date.getMonth() + 1)
      .toString()
      .padStart(2, "0")}. ${date.getDate().toString().padStart(2, "0")}`;
  };

  return (
    <span style={{ marginTop: "10px" }}>
      혜택 기간 : {formatDate(startDate)} ~ {formatDate(endDate)}
    </span>
  );
}

export default BenefitPeriod;
